import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Chemburtopunecab() {



const cardData = {
  keyword: " Chembur to Pune Cab  ",

headingDescription: "Velocity Cab provides reliable and comfortable Chembur to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Chembur to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Chembur to Pune cab travel.",

topPlaces: [

  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a scenic waterfront location near Pune known for its calm lake views and refreshing environment. It is a popular spot for evening outings, photography, and relaxing drives by sedan cab."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is an iconic fort in Pune that showcases the grandeur of the Maratha Empire. Visitors can explore its historic gates, ruins, and enjoy the captivating evening light and sound show."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a peaceful riverside park in Pune offering greenery, walking paths, and boating activities. It is ideal for relaxation, family outings, and evening walks."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a significant heritage site linked to India’s freedom struggle. It features elegant architecture, peaceful gardens, and a museum dedicated to Mahatma Gandhi."
  },
    {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a premier shopping and entertainment destination featuring top international brands, dining options, multiplex cinemas, and entertainment zones. Travelers booking a sedan cab in Pune can enjoy a complete leisure experience with shopping, food, and movies in one place."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a historic hilltop destination offering panoramic views of Pune city. Visitors can climb the stone steps to explore ancient temples and enjoy a peaceful atmosphere with scenic sunrise and sunset views."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a beautifully designed Japanese-style garden with serene landscapes, ponds, and walking paths. It is perfect for relaxation and photography."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular garden in Pune known for its greenery and the famous Siddhivinayak Temple. It is a favorite destination for families and morning walkers."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases a vast collection of Indian artifacts, sculptures, and musical instruments, offering deep insights into India’s cultural heritage."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut Shiva temple carved from a single basalt rock. It is known for its spiritual atmosphere and historic significance."
  }
],



services: [
{
name: "Chembur to Pune Cab Fare",
description: "Chembur to Pune cab fare service provides transparent pricing and reliable transportation for passengers traveling between Chembur in Mumbai and Pune city. Travelers can choose from comfortable vehicles such as sedan, Ertiga, and Innova Crysta depending on their travel needs. The journey through the Mumbai–Pune Expressway ensures smooth and fast intercity travel. Professional drivers provide punctual pickup from Chembur residential societies, offices, hotels, and commercial areas. This service is ideal for corporate travelers, families, and tourists traveling between Mumbai and Pune. Air-conditioned vehicles and spacious seating ensure comfortable long-distance travel. Online booking options allow passengers to reserve taxis easily with instant confirmation and clear pricing."
},
{
name: "Chembur to Baner Cab Fare",
description: "Chembur to Baner cab service provides reliable transportation between Chembur in Mumbai and the Baner area of Pune. Travelers can enjoy comfortable rides in well-maintained vehicles such as sedan, Ertiga, and Innova. Professional drivers ensure safe driving and punctual pickups from homes, offices, and hotels across Chembur. This route is widely used by corporate travelers visiting IT companies and business hubs located in Baner. Air-conditioned vehicles and spacious interiors ensure comfortable travel during the long-distance journey. Online cab booking allows passengers to schedule rides according to their preferred timing."
},
{
name: "Chembur to Pimpri Chinchwad Cab Fare",
description: "Chembur to Pimpri Chinchwad cab service offers dependable transportation between Chembur and the PCMC region of Pune. Travelers can book comfortable vehicles including sedan, Ertiga, and Innova for smooth expressway travel. Professional drivers provide punctual pickup services from Chembur East and Chembur West areas. This service is commonly used by business travelers visiting industrial zones and corporate offices in Pimpri Chinchwad. Spacious seating and air-conditioned vehicles make long-distance journeys relaxing and convenient."
},
{
name: "Chembur to Pune Station Cab",
description: "Chembur to Pune station cab service offers convenient transportation between Chembur and Pune Railway Station. Travelers arriving or departing from Pune station can book comfortable taxis for smooth highway travel. Professional drivers ensure timely pickups and safe driving via the Mumbai–Pune Expressway. Vehicles such as sedan, Ertiga, and Innova are available to suit individual or family travel requirements. This service is ideal for passengers connecting train journeys with intercity cab travel."
},
{
name: "Chembur to Pune Shivaji Nagar Cab",
description: "Chembur to Shivaji Nagar cab service provides reliable intercity transportation between Chembur in Mumbai and Shivaji Nagar in Pune. Travelers can enjoy comfortable rides in air-conditioned vehicles such as sedan, Ertiga, and Innova. Professional drivers provide punctual pickup services and safe highway travel. This route is widely used by business travelers, students, and tourists visiting central Pune locations including Shivaji Nagar and nearby areas."
},
{
name: "Chembur to Koregaon Park Cab",
description: "Chembur to Koregaon Park cab service offers dependable transportation between Chembur and the Koregaon Park area of Pune. Comfortable vehicles ensure smooth expressway travel while professional drivers provide punctual pickup services. This service is popular among travelers visiting hotels, restaurants, and corporate offices located in Koregaon Park. Air-conditioned vehicles and spacious seating ensure comfortable long-distance journeys."
},
{
name: "Chembur to Pune Innova Crysta",
description: "Chembur to Pune Innova Crysta taxi service provides premium SUV transportation for travelers seeking luxury and comfort. The Toyota Innova Crysta offers spacious seating, excellent suspension, and smooth highway performance. Professional drivers provide safe driving and punctual pickups from residential and commercial areas across Chembur. This service is ideal for corporate travel, airport transfers, and family trips."
},
{
name: "Chembur to Pune Sedan Cabs",
description: "Chembur to Pune sedan cab service offers economical transportation using vehicles such as Swift Dzire, Etios, and Hyundai Xcent. These cars are ideal for individuals and small families traveling between Mumbai and Pune. Professional drivers ensure punctual pickups and smooth highway travel through the expressway. Air-conditioned vehicles ensure comfortable long-distance journeys."
},
{
name: "Chembur to Pune Taxi Fare",
description: "Chembur to Pune taxi fare service provides transparent and competitive pricing for passengers planning intercity travel. Travelers can select vehicles based on comfort and budget preferences including sedan, Ertiga, and Innova. Professional drivers ensure safe driving and punctual pickup services from Chembur residential and commercial areas. Clear pricing helps passengers plan their travel budget easily."
},
{
name: "Chembur to Kharadi Cab Fare",
description: "Chembur to Kharadi cab service provides convenient transportation between Chembur in Mumbai and the Kharadi area of Pune. Travelers can book comfortable vehicles such as sedan, Ertiga, and Innova for smooth expressway travel. Professional drivers provide safe driving and punctual pickups from Chembur homes, offices, and hotels. This route is commonly used by corporate travelers visiting IT parks and business centers in Kharadi."
},
{
name: "Chembur to Pune Cab",
description: "Chembur to Pune cab service offers dependable intercity transportation between Mumbai and Pune. Travelers can enjoy comfortable rides in air-conditioned vehicles with professional drivers ensuring safe highway travel. Pickup services are available across Chembur including residential complexes, offices, and hotels. Online booking options allow passengers to reserve taxis quickly and conveniently."
},
{
name: "Chembur to Shivaji Nagar Cab",
description: "Chembur to Shivaji Nagar cab service offers reliable transportation between Chembur and the Shivaji Nagar area of Pune. Comfortable vehicles and experienced drivers ensure smooth expressway travel. This service is commonly used by students, business travelers, and tourists visiting central Pune locations."
},
{
name: "Chembur to Pune One Way Cab",
description: "Chembur to Pune one way cab service offers economical transportation for travelers who require single-direction travel between Mumbai and Pune. Passengers benefit from affordable fares as they only pay for one-way travel. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth highway journeys."
},
{
name: "Pune to Sion Taxi Fare",
description: "Pune to Sion taxi service provides reliable transportation between Pune city and the Sion area of Mumbai. Travelers can enjoy comfortable rides in vehicles such as sedan, Ertiga, and Innova. Professional drivers ensure safe highway travel and punctual pickups from homes, offices, and hotels across Pune."
},
{
name: "Taxi Service in Chembur Mumbai",
description: "Taxi service in Chembur Mumbai offers reliable transportation for city travel, airport transfers, and outstation journeys. Travelers can book comfortable vehicles with experienced drivers for safe travel across Mumbai and nearby destinations including Pune."
},
{
name: "Best Taxi Service in Chembur Mumbai",
description: "Best taxi service in Chembur Mumbai provides premium transportation with well-maintained vehicles and professional drivers. Travelers can enjoy comfortable rides for airport transfers, corporate travel, and long-distance trips to Pune and nearby cities."
},
{
name: "Best Taxi Service in Chembur Mumbai Contact Number",
description: "Best taxi service in Chembur Mumbai contact number helps passengers quickly connect with reliable cab providers for city and outstation travel. Travelers can easily book taxis for Pune trips, airport transfers, and daily commuting with quick booking assistance."
},
{
name: "Chembur to Pune Taxi",
description: "Chembur to Pune taxi service offers convenient and reliable transportation between Mumbai and Pune. Comfortable vehicles and experienced drivers ensure smooth expressway journeys."
},
{
name: "Chembur to Pune Cab Service",
description: "Chembur to Pune cab service provides dependable intercity transportation with professional drivers and comfortable vehicles ensuring safe travel."
},
{
name: "Chembur to Pune Taxi Booking",
description: "Chembur to Pune taxi booking allows passengers to easily reserve taxis online with instant confirmation and transparent pricing."
},
{
name: "Chembur to Pune Drop Taxi",
description: "Chembur to Pune drop taxi service offers convenient one-way transportation with comfortable vehicles and affordable fares."
},
{
name: "Chembur to Pune Online Cab Booking",
description: "Chembur to Pune online cab booking allows travelers to quickly reserve taxis through websites or mobile platforms for convenient intercity travel."
},
{
name: "Chembur to Pune Private Cab",
description: "Chembur to Pune private cab service provides exclusive transportation for passengers seeking privacy and flexible pickup timing during their journey."
}
],

tableData: [
["Chembur to Pune Cab Fare","Chembur to Baner Cab Fare"],
["Chembur to Pimpri Chinchwad Cab Fare","Chembur to Pune Station Cab"],
["Chembur to Pune Shivaji Nagar Cab","Chembur to Koregaon Park Cab"],
["Chembur to Pune Innova Crysta","Chembur to Pune Sedan Cabs"],
["Chembur to Pune Taxi Fare","Chembur to Kharadi Cab Fare"],
["Chembur to Pune Cab","Chembur to Shivaji Nagar Cab"],
["Chembur to Pune One Way Cab","Pune to Sion Taxi Fare"],
["Taxi Service in Chembur Mumbai","Best Taxi Service in Chembur Mumbai"],
["Best Taxi Service in Chembur Mumbai Contact Number","Chembur to Pune Taxi"],
["Chembur to Pune Cab Service","Chembur to Pune Taxi Booking"],
["Chembur to Pune Drop Taxi","Chembur to Pune Online Cab Booking"],
["Chembur to Pune Private Cab","Chembur to Pune Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Chembur to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Chembur to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Chembur to Pune cab service operates 24 hours a day. Whether you need an early morning ride, airport transfer, business travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Chembur to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Chembur",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Chembur including Chembur East, Chembur West, and nearby locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Chembur to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Chembur to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Chembur to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Chembur from Pune?", answer: "The road distance between Chembur and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Chembur to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Chembur to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Chembur to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Chembur and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, railway stations, and residential areas across Chembur." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Chembur to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prasad Mane",
    feedback:
      "My Chembur to Pune journey with Velocity Cabs was very comfortable and well-organized. The cab arrived on time, the driver was skilled, and the ride was smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Shah",
    feedback:
      "I had a great experience traveling from Chembur to Pune. The vehicle was clean, the pickup was punctual, and the entire journey felt safe and relaxed.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Chembur to Pune Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides safe and reliable Chembur to Pune taxi service. Choose from Innova, Innova Crysta, Ertiga, and Sedan cabs for one way, round trip, and airport transfers. Affordable, comfortable, and 24x7 service from Chembur, Mumbai to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2300"
  }
};










  return (
    <div>
      <Helmet>
  <title>Chembur to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Chembur to Pune cab with Velocity Cabs. One way & round trip cabs including Innova, Innova Crysta, Ertiga & Sedan for airport transfers, corporate trips & city travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/53.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Chemburtopunecab;